/* eslint-disable import/prefer-default-export */
import iconJobStageBefore from 'images/icon-jobstage-before.png';
import iconJobStageDuring from 'images/icon-jobstage-during.png';
import iconJobStageAfter from 'images/icon-jobstage-after.png';
import iconJobStageBusiness from 'images/icon-jobstage-business.png';
import iconJobStageOther from 'images/icon-jobstage-other.png';

export const jobStageData = {
  all: {
    label: 'All Stages of the Job',
  },
  before: {
    label: 'Before the Job',
    icon: iconJobStageBefore,
  },
  on: {
    label: 'On the Job',
    icon: iconJobStageDuring,
  },
  after: {
    label: 'After the Job',
    icon: iconJobStageAfter,
  },
  running: {
    label: 'Running Your Business',
    icon: iconJobStageBusiness,
  },
  other: {
    label: 'Other Resources',
    icon: iconJobStageOther,
  },
};
